const DialogStyles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        fontFamily: 'Raleway, Arial',
        userSelect: 'none'
    },
    dButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    }
    ,
    closeButton: {
        width: '7em',
        backgroundColor: 'rgba(239, 246, 255, 1)',
        boxSizing: 'border-box',
        lineHeight: '1',
        fontSize: "0.875rem",
        fontFamily: 'Raleway, Arial',
        overflow: 'hidden',
        color: 'rgba(75, 85, 99,1)',
        borderColor: 'rgba(222, 226, 230,1)',
        border: 'solid',
        borderWidth: '1px',
        display: 'inline-block',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
        paddingBottom: '.5rem',
        paddingTop: '.5rem',
        marginTop: '.25rem',
        borderRadius: '.25rem',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: 'rgba(209 ,233 ,251, 1)',
        },
        "& .MuiTouchRipple-child": {
            color: "red!important",
            margin: 0,
            borderRadius: 0,
            padding: 0,
            width: '100%',
            height: '100%'
        },
        "& .MuiTouchRipple-childPulsate": {
            animation: ''
        }
    },
    rippleVisible: {
        opacity: 0.5,
        animation: `$enter 550ms ${theme.transitions.easing.easeInOut}`
    },
    "@keyframes enter": {
        "0%": {
            transform: "scale(0)",
            opacity: 0.1
        },
        "100%": {
            transform: "scale(1)",
            opacity: 0.5
        }
    },
    browseButton: {
        width: '5em',
        backgroundColor: 'rgba(239, 246, 255, 1)',
        boxSizing: 'border-box',
        lineHeight: '0.6em',
        fontSize: "0.875rem",
        fontFamily: 'Raleway, Arial',
        overflow: 'hidden',
        color: 'rgba(75, 85, 99,1)',
        borderColor: 'rgba(222, 226, 230,1)',
        border: 'solid',
        borderWidth: '1px',
        display: 'inline-block',
        paddingLeft: '1.5rem',
        paddingRight: '0.75rem',
        paddingBottom: '.5rem',
        paddingTop: '.5rem',
        marginTop: '.25rem',
        borderRadius: '.25rem',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: 'rgba(209 ,233 ,251, 1)',
        }
    }
    ,
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: '1200px',
        outerHeight: '600px'
    }
});
export default DialogStyles;